import script from "./MyOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./MyOrders.vue?vue&type=script&setup=true&lang=js"

import "./MyOrders.vue?vue&type=style&index=0&id=313723cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313723cf"]])

export default __exports__